import { Action } from "redux"

import * as actions from "./actions"
import { IConceptsPage } from "./index"

export const initialState: IConceptsPage = {
    conceptsInfo: {
        concepts: [],
        filter: {
            concept: {
                label: "",
                code: "",
            },
            workspace: {
                label: "",
                code: "",
            },
            includeInstances: false,
            isActive: true,
        },
        isLoading: false,
        paging: {
            hasMore: false,
            page: 0,
            pageSize: 25,
            totalCount: 0,
        },
    },
    initialized: false,
    createConceptVisible: false,
    workspacesInfo: {
        filter: "",
        isLoading: false,
        pagination: {
            currentPage: 1,
            // See Presenters/GDL/DataList.cs L55
            pageSize: 15,
            count: 0,
        },
        workspaces: [],
    },
}

const ACTION_HANDLERS: {
    [action: string]: (state: IConceptsPage, props: Action) => IConceptsPage
} = {
    [actions.SET_INITIALIZED]: (state): IConceptsPage => ({
        ...state,
        initialized: true,
    }),

    [actions.LOAD_MORE_CONCEPTS]: (state): IConceptsPage => ({
        ...state,
        conceptsInfo: {
            ...state.conceptsInfo,
            paging: {
                ...state.conceptsInfo.paging,
                page: state.conceptsInfo.paging.page + 1,
            },
        },
    }),

    [actions.REQUEST_CONCEPTS]: (state): IConceptsPage => ({
        ...state,
        conceptsInfo: {
            ...state.conceptsInfo,
            isLoading: true,
        },
    }),

    [actions.RECEIVE_CONCEPTS]: (
        state,
        { concepts }: actions.ReceiveConcepts,
    ): IConceptsPage => ({
        ...state,
        conceptsInfo: {
            ...state.conceptsInfo,
            concepts,
            isLoading: false,
        },
    }),

    [actions.FILTER_CONCEPTS]: (
        state,
        { filter }: actions.FilterConcepts,
    ): IConceptsPage => ({
        ...state,
        conceptsInfo: {
            ...state.conceptsInfo,
            filter,
            isLoading: true,
            paging: {
                ...state.conceptsInfo.paging,
                page: 0,
            },
        },
    }),

    [actions.UPDATE_CREATE_CONCEPT_VISIBILITY]: (
        state,
        { createConceptVisible }: actions.UpdateCreateConceptVisibility,
    ): IConceptsPage => ({
        ...state,
        createConceptVisible,
    }),

    [actions.REQUEST_WORKSPACES]: (state): IConceptsPage => ({
        ...state,
        workspacesInfo: {
            ...state.workspacesInfo,
            isLoading: true,
        },
    }),

    [actions.RECEIVE_WORKSPACES]: (
        state,
        { pagination: { count }, workspaces }: actions.ReceiveWorkspaces,
    ): IConceptsPage => ({
        ...state,
        workspacesInfo: {
            ...state.workspacesInfo,
            pagination: {
                ...state.workspacesInfo.pagination,
                count,
            },
            // if this is the first page, we replace otherwise we append
            workspaces:
                state.workspacesInfo.pagination.currentPage === 1
                    ? workspaces
                    : state.workspacesInfo.workspaces.concat(...workspaces),
            isLoading: false,
        },
    }),

    [actions.FILTER_WORKSPACES]: (
        state,
        { filter }: actions.FilterWorkspaces,
    ): IConceptsPage => ({
        ...state,
        workspacesInfo: {
            ...state.workspacesInfo,
            filter,
            pagination: {
                ...state.workspacesInfo.pagination,
                currentPage: 1,
            },
            isLoading: true,
            workspaces: [],
        },
    }),

    [actions.LOAD_MORE_WORKSPACES]: (state): IConceptsPage => ({
        ...state,
        workspacesInfo: {
            ...state.workspacesInfo,
            pagination: {
                ...state.workspacesInfo.pagination,
                currentPage: state.workspacesInfo.pagination.currentPage + 1,
            },
            isLoading: true,
        },
    }),
}

export default function reducer(
    state: IConceptsPage = initialState,
    action: Action,
): IConceptsPage {
    const handler: (state: IConceptsPage, action: Action) => IConceptsPage =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
